// extracted by mini-css-extract-plugin
export var black = "_3p-6";
export var brand = "_3p-1";
export var ddefault = "_3p-0";
export var error = "_3p-3";
export var gray = "_3p-2";
export var highContrast = "_3p-8";
export var outline = "_3p-7";
export var success = "_3p-5";
export var warning = "_3p-4";